import { useFormik } from "formik";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  //useState,
} from "react";
import toast from "react-hot-toast";
import { userFormValidate } from "../../../../helper/validate";

import * as api from "helper/helper";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import { withMask } from "use-mask-input";
import { onlyNumbers, Singleton } from "helper/tools";
import LoadingButton from "../LoadingButton/LoadingButton";

const ChangeCreditLimitModal = forwardRef(
  ({ item, onOk, reloadUsuarios }, ref) => {
    const modalButtonRef = useRef();

    const [canSave, setCanSave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      toggleModal: () => {
        formik?.resetForm();
        modalButtonRef.current.click();

        setCanSave(false);
      },
    }));

    //
    //let montoActual = item?.actual ?? 0;
    let initialValues = {
      montoNuevo: "0",
      mensaje: "",
    };

    if (item) {
      initialValues = {
        montoNuevo: "0",
        mensaje: "",
      };
    }

    useEffect(() => {
      setCanSave(false);
    }, [item]);

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: userFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {
        //is - invalid;

        //const className = `nav-link collapsed ${isSelected ? "selected" : ""}`;
        //console.log(values);
        //setUsername(values.username);
        //navigate("/password");

        if (values.id) {
          let createUsuarioPromise = api.updateUsuario(values.id, values);
          toast.promise(createUsuarioPromise, {
            loading: "Actualizando Usuario...",
            success: <b>Usuario Actualizado...!</b>,
            error: <b>Error al Actualizar Usuario</b>,
          });

          createUsuarioPromise.then((res) => {
            console.log("");
            reloadUsuarios();

            formik.resetForm();

            //buttonCancelModalRef.current.click();
          });

          return;
        }

        let createUsuarioPromise = api.createUsuario(values);
        toast.promise(createUsuarioPromise, {
          loading: "Creando Usuario...",
          success: <b>Usuario Creado...!</b>,
          error: <b>Error al Crear Usuario</b>,
        });

        createUsuarioPromise.then((res) => {
          console.log("");
          reloadUsuarios();

          formik.resetForm();

          //buttonCancelModalRef.current.click();
        });
      },
    });

    const credito = Singleton.getInstance().format(item?.limiteCredito ?? "0");

    return (
      <>
        {/*<!-- Button trigger modal -->*/}
        <button
          ref={modalButtonRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropChangeCreditLimit"
          hidden
        >
          Launch static backdrop modal
        </button>

        {/*<!-- Modal -->*/}
        <div
          className="modal fade"
          id="staticBackdropChangeCreditLimit"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropChangeCreditLimitLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropChangeCreditLimitLabel"
                >
                  Solicitar Cambio Limite de Credito
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {/*<div className="alert alert-warning" role="alert">
                  Ya existe una peticion de cambio de limite de credito de{" "}
                  <b>$3,000</b> a <b>$30,000</b> en{" "}
                  <b>Pendiente de aprobación.</b>
                  <br />
                  <small>
                    Si Aplica a una nuevo cambio de limite, la anterior se
                    cancelara
                  </small>
                </div>*/}
                <form className="row" onSubmit={formik.handleSubmit}>
                  <div className="mb-3">
                    <div className="mb-3 row">
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Monto Actual
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          id="validationName"
                          aria-describedby="emailHelp"
                          defaultValue={credito}
                          value={credito}
                          aria-label="readonly input example"
                          readOnly
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.montoActual}
                        </div>
                      </div>

                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Monto Nuevo
                        </label>
                        <input
                          ref={withMask("currency", {
                            groupSeparator: ",",
                            digits: 0,
                            numericInput: true,
                            rightAlign: false,
                            allowMinus: false,
                          })}
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.montoNuevo,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          value={formik.values.montoNuevo}
                          onChange={async (e) => {
                            const aValue = onlyNumbers(e.target.value);

                            formik.setFieldValue("montoNuevo", aValue);

                            setCanSave(aValue > 0);
                          }}
                        />
                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.montoNuevo}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Deja Mensaje para Revisión"
                          id="floatingTextarea2"
                          {...formik.getFieldProps("mensaje")}
                          {...formikExtra.upperCase("mensaje", formik)}
                          style={{ height: "100px" }}
                        ></textarea>
                        <label htmlFor="floatingTextarea2">Mensaje</label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>

                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    const value = formik.getFieldProps("montoNuevo").value;
                    const newValue = onlyNumbers(value);
                    const asociadoId = item.id;

                    //const toastId = toast.loading("Solicitando...");

                    setIsLoading(true);
                    const response = await api
                      .asociadosSolicitudesCreate({
                        asociadoId: asociadoId,
                        tipoDeSolicitud: "LimiteCredito",
                        fecha: new Date().toJSON(),
                        mensaje: formik.values.mensaje,
                        limiteCreditoSolicitado: newValue,
                      })
                      .catch((e) => {
                        //  toast.dismiss(toastId);
                        setIsLoading(false);
                        if (e.esError && e.codigoError && e.mensaje) {
                          toast.error(`${e.mensaje}`);
                          return;
                        }
                        toast.error(
                          "Error al Solicitar Cambio Limite de Credito",
                        );
                      });

                    //  toast.dismiss(toastId);

                    setIsLoading(false);

                    if (!response) return;

                    modalButtonRef.current.click();
                    toast.success(
                      <b>Se realizo solicitud de cambio en Asociado</b>,
                    );
                  }}
                  text={"Solicitar"}
                  loadingText={"Solicitando..."}
                  isDisable={!canSave}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default ChangeCreditLimitModal;
